import type { ReactNode } from "react";
import { useSearchParams } from "react-router";
import { WayflyerError } from "shared-ui";

import { UploadDocumentType } from "../../types";

import {
  BalanceSheetDocumentUploadPage,
  CashFlowForecastDocumentUploadPage,
  DebtAgreementsDocumentUploadPage,
  ManagementAccountsDocumentUploadPage,
  PoolBancarioDocumentUploadPage,
  ProfitAndLossDocumentUploadPage,
  SusaDocumentUploadPage,
} from "./document-uploads-pages";

const DocumentUploadComponents: Record<string, ReactNode> = {
  [UploadDocumentType.SUSA]: <SusaDocumentUploadPage />,
  [UploadDocumentType.POOL_BANCARIO]: <PoolBancarioDocumentUploadPage />,
  [UploadDocumentType.COMPANY_DEBT_AGREEMENT]: <DebtAgreementsDocumentUploadPage />,
  [UploadDocumentType.CASH_FLOW_FORECAST]: <CashFlowForecastDocumentUploadPage />,
  [UploadDocumentType.MANAGEMENT_ACCOUNTS]: <ManagementAccountsDocumentUploadPage />,
  [UploadDocumentType.PROFIT_AND_LOSS]: <ProfitAndLossDocumentUploadPage />,
  [UploadDocumentType.BALANCE_SHEET]: <BalanceSheetDocumentUploadPage />,
};

export const DocumentUploadManager = () => {
  const [searchParams] = useSearchParams();

  const pagesCollection = DocumentUploadComponents;
  const document = searchParams.get("document");

  if (!document || !(document in pagesCollection)) {
    throw new WayflyerError("Missing or unknown document type", "404");
  }

  return pagesCollection[document];
};
